import AtomicConsentView from '@/components/atomic/AtomicConsentView';
import { useToasts } from '@/components/common/Toasts';
import { useIdvContext } from '@/components/idv/IdvProvider';
import { useJustSubmittedIndividualConsent } from '@/components/idv/useJustSubmittedIndividualConsent';
import { useTrackPageViewed } from '@/services/analytics/useTracking';
import { useStartIndividualAccountOpening } from '@common/react/idv/useStartIndividualAccountOpening';
import { openAtomicIndividualAccount20240405 } from '@common/terms';
import { TOASTS } from '@common/toasts';
import { useModal } from '@ebay/nice-modal-react';

const atomicConsentInput = {
    title: openAtomicIndividualAccount20240405.title,
    method: 'BUTTON' as const,
    contents: openAtomicIndividualAccount20240405.contents,
    buttonText: 'Continue',
};

export const IndividualConsentView = () => {
    useTrackPageViewed('IDV > IndividualConsentView');
    const [, setJustSubmittedIndividualConsent] =
        useJustSubmittedIndividualConsent();

    const modal = useModal();
    const { showErrorToast } = useToasts();
    const { onComplete, consentTitle, consentSubtitle } = useIdvContext();

    const { startIndividualAccountOpening, isLoading } =
        useStartIndividualAccountOpening({
            atomicConsentInput,
            onComplete: () => {
                setJustSubmittedIndividualConsent(true);
                modal.remove();
                onComplete();
            },
            onError: () => {
                showErrorToast(TOASTS.confirmConsentError);
            },
        });

    return (
        <AtomicConsentView
            title={consentTitle}
            description={consentSubtitle}
            onSubmit={startIndividualAccountOpening}
            isLoading={isLoading}
            isDisabled={isLoading}
            consentInput={atomicConsentInput}
        />
    );
};
